import { render, staticRenderFns } from "./modal_edit.vue?vue&type=template&id=1b87ce0e&scoped=true&"
import script from "./modal_edit.vue?vue&type=script&lang=js&"
export * from "./modal_edit.vue?vue&type=script&lang=js&"
import style0 from "./modal_edit.vue?vue&type=style&index=0&id=1b87ce0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b87ce0e",
  null
  
)

export default component.exports